import { useState } from "react";
import { getTests } from "./../services/Model";
import { ToastContainer, toast } from "react-toastify";
import { Button, Spinner } from "react-bootstrap";

function TestForm({ setTests }) {
  const [patientID, setPID] = useState("");
  const [testID, setTID] = useState("");
  let [loading, setLoading] = useState(false);
  let [searchText, setSearchTest] = useState("Search");

  const getPatientTests = async () => {
    setLoading(!loading);
    setSearchTest("Searching");

    // Strip leading zeros so "001234" and "1234" both match the backend record
    const normalizedPID = patientID.replace(/^0+(?=\d)/, "");

    try {
      let testsFound = await getTests(normalizedPID, testID);
      testsFound = testsFound.data.rows;
      console.log(testsFound);
      setTests(testsFound);
      setLoading(false);
      toast.success(`${testsFound.length} Tests found`);
    } catch (err) {
      if (err.response && err.response.status === 400) {
        toast.error(err.response.data);
        setLoading(false);
      }
    }
  };

  return (
    <div className="mx-auto text-center thi-report-wrapper sweet-loading">
      <p>
        <input
          onChange={(e) => setPID(e.target.value)}
          type="text"
          className="form-control form-control-lg"
          placeholder="50354"
        />
      </p>
      <p>
        <input
          onChange={(e) => setTID(e.target.value)}
          type="text"
          className="form-control form-control-lg"
          placeholder="7973671"
        />
      </p>
      <Button
        onClick={() => getPatientTests()}
        variant="primary"
        className="thi-report-button"
      >
        {loading && (
          <Spinner
            as="span"
            animation="grow"
            size="sm"
            role="status"
            aria-hidden="true"
          />
        )}
        {searchText}
      </Button>

      <ToastContainer />
    </div>
  );
}

export default TestForm;
